import React, { useState } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

/// Css
import './index.css'
import './chart.css'
import './step.css'

// components
import Agent from '../containers/Agent'
import Books from '../containers/Books'
import Configs from '../containers/Configs'
// import NewConfig from '../containers/NewConfig';
import Credit from '../containers/Credit'
import Admin from '../containers/Admin'
import Log from '../containers/Log'
import Lottery from '../containers/Lottery'
import Monitor from '../containers/Monitor'
import Order from '../containers/Order'
import OrderSlot from '../containers/OrderSlot'
import Prize from '../containers/Prize'
import Round from '../containers/Round'
import SaningTeam from '../containers/SaningTeam'
import Scaning from '../containers/Scaning'
import Transfer from '../containers/Transfer'
import TransferSlip from '../containers/TransferSlip'
import User from '../containers/User'
import UserPrizes from '../containers/UserPrizes'
import Withdrawal from '../containers/Withdrawal'
import Login from '../containers/Login'
import Member from '../components/Member'
import NumberOfPrizes from '../containers/NumberOfPrizes'
import Affiliate from '../containers/Affiliate'
import KYC from '../containers/KYC'
import WithdrawalRequest from '../containers/WithdrawalRequest'
import LuckyNumber from '../containers/LuckyNumber'
import BadQR from '../containers/BadQR'
import TempImport from '../containers/TempImport'
import OrderExtras from '../containers/OrderExtras'
//import SaleLottery from "../containers/SaleLottery";
// Error
import Error400 from '../page/Error400'
import Error403 from '../page/Error403'
import Error404 from '../page/Error404'
import Error500 from '../page/Error500'
import Error503 from '../page/Error503'

import Nav from '../components/Nav'
import Announcement from '../containers/Announcement'
import AnnouncementBox from '../containers/Announcement/AnnouncementBox'
import Notification from '../containers/Notification'
import PermissionRoute from '../components/routes/PermissionRoute'
import PrivateRoute from '../components/routes/PrivateRoute'
import LineLogin from '../components/routes/LineLogin'
import callapi from '../helpers/callapi'
import Permission from '../containers/Permission'
import { setAdmin } from '../reducers/admin/adminSlice'
import { useDispatch, useSelector } from 'react-redux'
import Cookies from 'js-cookie'
import FCM from '../containers/FCM'
import DashboardScan from '../containers/DashboardScan'
import Refunds from '../containers/Refunds'
import Campaign from '../containers/Campaign'
import Gifts from '../containers/Gifts'
import TransferMhee from '../containers/TransferMhee'
import PayOutMhee from '../containers/PayOutMhee'
import PayOut from '../containers/PayOut'
import RecheckPrizes from '../containers/RecheckPrizes'
import PrizeSummary from '../containers/RecheckPrizes/Detail'
import RecheckPrizes2 from '../containers/RecheckPrizes2'
import LotteryTemp from '../containers/LotteryTemp'
import Refund from '../containers/Refund'
import MoveLottery from '../containers/MoveLottery'
import RecheckShipping from '../containers/RecheckShipping'
import OpenBox from '../containers/OpenBox'
import HighlightLottery from '../containers/HighlightLottery'
import LotteryLive from '../containers/LotteryLive'
import Payment from '../containers/Payment'
import EditPolicy from '../containers/EditPolicy'
import PreOrder from '../containers/PreOrder'
import LotterySafe from '../containers/LotterySafe'
import AdBanner from '../containers/AdBanner'
import BookBankCollection from '../containers/BookBankCollection'
import Coupon from '../containers/Coupon'
import LotteryCountByNumber from '../containers/LotteryCountByNumber'
import RedirectDashboard from '../containers/DashboardDraft/Redirect'

const routes = [
  // Components
  { url: '', component: RedirectDashboard },
  { url: 'refund', component: Refund },
  { url: 'dashboard-draft', component: RedirectDashboard },
  { url: 'affiliate', component: Affiliate },
  { url: 'kyc', component: KYC },
  { url: 'withdrawalRequest', component: WithdrawalRequest },
  { url: 'dashboardScan', component: DashboardScan },
  { url: 'agent', component: Agent },
  { url: 'books', component: Books },
  { url: 'campaign', component: Campaign },
  { url: 'adBanner', component: AdBanner },
  { url: 'config', component: Configs },
  { url: 'bookBankCollection', component: BookBankCollection },
  { url: 'coupon', component: Coupon },
  { url: 'credit', component: Credit },
  { url: 'admin', component: Admin },
  { url: 'log', component: Log },
  { url: 'lottery', component: Lottery },
  { url: 'lotteryLive', component: LotteryLive },
  { url: 'lotteryTemp', component: LotteryTemp },
  { url: 'lotterySafe', component: LotterySafe },
  { url: 'lotteryCountByNumber', component: LotteryCountByNumber },
  { url: 'monitor', component: Monitor },
  { url: 'order', component: Order },
  { url: 'payment', component: Payment },
  { url: 'preOrder', component: PreOrder },
  { url: 'orderExtras', component: OrderExtras },
  { url: 'prize', component: Prize },
  { url: 'round', component: Round },
  { url: 'scaningTeam', component: SaningTeam },
  { url: 'scaning', component: Scaning },
  { url: 'transfer', component: Transfer },
  { url: 'transferSlip', component: TransferSlip },
  { url: 'numberOfPrizes', component: NumberOfPrizes },
  { url: 'user', component: User },
  { url: 'userPrizes', component: UserPrizes },
  { url: 'withdrawal', component: Withdrawal },
  { url: 'page-login', component: Login },
  { url: 'member', component: Member },
  { url: 'announcements', component: Announcement },
  { url: 'luckyNumber', component: LuckyNumber },
  { url: 'badQR', component: BadQR },
  { url: 'tempImport', component: TempImport },
  { url: 'refunds', component: Refunds },
  //{ url: "saleLottery", component: SaleLottery },
  { url: 'fcm', component: FCM },
  { url: 'gifts', component: Gifts },
  { url: 'transferMhee', component: TransferMhee },
  { url: 'payOutMhee', component: PayOutMhee },
  { url: 'recheckPrizes', component: RecheckPrizes },
  { url: 'recheckPrizes2', component: RecheckPrizes2 },
  { url: 'moveLottery', component: MoveLottery },
  { url: 'payOut', component: PayOut },
  { url: 'recheckShipping', component: RecheckShipping },
  { url: 'openBox', component: OpenBox },
  { url: 'highlightLottery', component: HighlightLottery },
  { url: 'editPolicy', component: EditPolicy },

  // Page => Error
  { url: 'page-error-400', component: Error400 },
  { url: 'page-error-403', component: Error403 },
  { url: 'page-error-404', component: Error404 },
  { url: 'page-error-500', component: Error500 },
  { url: 'page-error-503', component: Error503 },
]

export default function Routes() {
  const dispatch = useDispatch()
  const admin = useSelector((state) => state.admin)
  const isAuthenticated = Cookies.get('accessToken') ? true : false
  const [permisseions, setPermisseions] = useState([])
  if (isAuthenticated && !admin.id) {
    callapi({ url: '/admins/me' })
      .then((response) => {
        dispatch(setAdmin(response))
        setPermisseions(response.permissions ? response.permissions : [])
      })
      .catch((err) => console.log(err))
  }
  let path = window.location.pathname

  path = path.split('/')
  path = path[path.length - 1]
  let pagePath = path.split('-').includes('page') || path === 'member'

  return (
    <Router basename="/">
      <div
        id={`${!pagePath ? 'main-wrapper' : ''}`}
        className={`${!pagePath ? 'show' : 'mh100vh'} ${!path ? 'right-profile' : ''}`}
      >
        {!pagePath && <Nav />}
        <div className={`${!pagePath ? 'content-body' : ''}`}>
          {!pagePath && (
            <div className="mt-2">
              <AnnouncementBox />
            </div>
          )}

          <div
            className={`${!pagePath ? 'container-fluid' : ''}`}
            style={{
              minHeight: window.screen.height - 1024,
              paddingTop: '8px',
            }}
          >
            <Switch>
              <Route path="/page-login" exact component={Login} />
              <Route path="/member" exact component={LineLogin} />
              <Route path="/permissions" exact component={Permission} />
              <Route path="/notificatins" exact component={Notification} />
              <Route path="/orderSlot" exact component={OrderSlot} />
              <Route path="/prizeDetail" exact component={PrizeSummary} />
              {/* <Route path='/new-config' exact component={NewConfig} /> */}
              <PrivateRoute>
                {routes.map((data, i) => (
                  <PermissionRoute
                    exact
                    key={i}
                    path={`/${data.url}`}
                    permissions={permisseions}
                    element={data.component}
                  />
                ))}
              </PrivateRoute>
            </Switch>
          </div>
        </div>
      </div>
    </Router>
  )
}
